import cloneDeep from 'lodash/cloneDeep';
import {
  REQUEST_SAVE_REPORTS,
  REQUEST_SAVE_REPORT,
  RESPONSE_SAVE_REPORT,
  REQUEST_SAVE_REPORT_FAILURE,
  CLEAR_SAVE_REPORTS
} from './../actions/saveReportActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: [],
  errors: [],
}

const saveReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SAVE_REPORTS: {
      let { report, selectedCars } = action.payload
      let savedReports = []
      if (report.length) {
        report.map((reportItem) => {
          let savedReport = {
            reportId: reportItem.id,
            reportTitle: reportItem.title,
            cars: selectedCars.map((carItem) => {
              return {
                id: carItem.id,
                name: carItem.name,
                dataState: states.NOT_REQUESTED
              }
            })
          }

          savedReports.push(savedReport)
        })
      } else {
        let savedReport = {
          reportId: report.id,
          reportTitle: report.title,
          cars: selectedCars.map((item) => {
            return {
              id: item.id,
              name: item.name,
              dataState: states.NOT_REQUESTED
            }
          })
        }

        savedReports.push(savedReport)
      }

      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST,
          data: savedReports
        }
      )
    }
    case REQUEST_SAVE_REPORT: {
      let { reportId, carId } = action.payload
      let nextState = cloneDeep(state)
      let savedReports = nextState.data
      let reportReady = savedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.REQUEST

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case RESPONSE_SAVE_REPORT: {
      let { reportId, carId } = action.payload
      let nextState = cloneDeep(state)
      let savedReports = nextState.data
      let reportReady = savedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.READY

      if (savedReports.every(
        reportItem => reportItem.cars.every(
          carItem => carItem.dataState === states.READY
        )
      )) {
        nextState.dataState = states.READY
      }

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case REQUEST_SAVE_REPORT_FAILURE: {
      let { reportId, carId, errors } = action.payload
      let nextState = cloneDeep(state)
      let savedReports = nextState.data
      let reportReady = savedReports.find(item => item.reportId === reportId)
      let carReady = reportReady.cars.find(item => item.id === carId)
      carReady.dataState = states.FAILURE
      carReady.errors = errors

      if (savedReports.some(
        reportItem => reportItem.cars.some(
          carItem => carItem.dataState === states.FAILURE
        )
      )) {
        nextState.dataState = states.FAILURE
      }

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    case CLEAR_SAVE_REPORTS: {
      return Object.assign(
        {},
        state,
        initialState
      )
    }
    default:
      return state
  }
}

export default saveReportReducer